module.exports = __webpack_public_path__ + "img/color.3ddc0522.jpg";